/**
 * BufferWidget — Buffer status (zonas verde/amarelo/vermelho).
 *
 * Permissao: toc:view. Indica quantas OPs estao em cada zona de consumo.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterDashboardToc } from "../../../services/toc";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "buffer",
  label: "Buffer status",
  descricao: "Quantas OPs estao em zonas verde/amarela/vermelha de consumo.",
  categoria: "TOC",
  permissoes: ["toc:view"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  return await obterDashboardToc(request, { janela: "30d" });
}

export function Widget({ dados }) {
  const b = dados?.buffer || {};
  const v = b.verde || 0;
  const a = b.amarelo || 0;
  const r = b.vermelho || 0;
  const total = v + a + r;
  return (
    <>
      <CardBody>
        <KpiValor>{r}</KpiValor>
        <KpiSub>OPs no vermelho{r > 0 ? " (ação urgente)" : ""}</KpiSub>
        <div style={{ marginTop: 8, display: "flex", gap: 8, fontSize: "0.82rem" }}>
          <span style={{ flex: 1, padding: "6px 8px", background: "var(--success-bg)", color: "var(--success-text)", borderRadius: 4, textAlign: "center" }}>
            <strong>{v}</strong><br/>Verde
          </span>
          <span style={{ flex: 1, padding: "6px 8px", background: "var(--warning-bg)", color: "var(--warning-text)", borderRadius: 4, textAlign: "center" }}>
            <strong>{a}</strong><br/>Amarelo
          </span>
          <span style={{ flex: 1, padding: "6px 8px", background: "var(--danger-bg)", color: "var(--danger-text)", borderRadius: 4, textAlign: "center" }}>
            <strong>{r}</strong><br/>Vermelho
          </span>
        </div>
        {total === 0 && (
          <KpiSub style={{ marginTop: 6 }}>Sem OPs ativas.</KpiSub>
        )}
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/producao/dbr">Ver DBR</LinkLight>
      </CardFooter>
    </>
  );
}
